import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { getPageParams, PageRequest, SpringPage } from '@shared/page';
import { addHttpParams } from '@shared/utils/request-utils';
import { SiteMode } from '@shared/services/hostMode.service';
import { Hsts } from '../models/site';
import { SiteRef, UpdateSiteRequest } from './organization-site.service';
import { ClusterUidAndName } from '../models/cluster';

import { OrganizationBase } from '@shared/services/organization.service';

@Injectable({
  providedIn: 'root',
})
export class AdminSiteService {
  constructor(private readonly http: HttpClient) {}

  getSites(siteQuery: SiteQuery = null, page: PageRequest = null): Observable<SpringPage<Site>> {
    let params = addHttpParams(siteQuery, getPageParams(page));

    return this.http.get<SpringPage<Site>>(`admin/sites`, { params });
  }

  updateSite(siteRef: SiteRef, request: AdminUpdateSiteRequest): Observable<Site> {
    return this.http.patch<Site>(siteUrl(siteRef), request);
  }

  setManaged(siteRef: SiteRef, managed: boolean): Observable<void> {
    return this.http.put<void>(`${siteUrl(siteRef)}/managed`, { value: managed });
  }

  provision(siteRef: SiteRef) {
    return this.http.post(siteUrl(siteRef) + '/provision', {});
  }

  refreshStatus(siteRef: SiteRef) {
    return this.http.post(siteUrl(siteRef) + '/refreshStatus', {});
  }

  refreshAllSites() {
    return this.http.post('jobs/cron12H?async=true', null);
  }
}

function siteUrl(domainName: SiteRef): string {
  return `admin/sites/${domainName}`;
}

export type Site = {
  domainName: string;
  originServer: string;
  originScheme: string;
  originPort: number;
  originMtlsEnabled: number;
  originSkipCertVerify: boolean;

  forceHttps: boolean;
  removeXForwarded: boolean;
  passthroughMode: boolean;
  auditMode: boolean;
  hsts: Hsts;
  logExportEnabled: boolean;
  cacheEnabled: boolean;

  managed: boolean;
  mode: SiteMode;
  owner: OrganizationBase;
  cluster: ClusterUidAndName;
  status: string;
  createdAt: string;
};

type AdminUpdateSiteRequest = UpdateSiteRequest & {
  managed?: boolean;
};

interface SiteQuery {
  cluster?: string | number;
  status?: string;
  mode?: string;
  filter?: string;
  contractIsNull?: boolean;
  owner?: string | number;
}
